jQuery(".explanation").mouseleave(function(){
    jQuery(this).data('popover').hide();
});